<mat-card>
  <app-cart-data-renderer [cart]="cart"></app-cart-data-renderer>
</mat-card>
